import { post, put, get } from "../Services/http";
import { load as loadCart } from "./Cart.action";
import { catchError } from "./Error.action";
import { showModal } from "./Modal.action";
import { CART_RECEIVE } from "../Actions/Cart.action";
import { hideSaveCartModel, showSaveCartModel, updateSavedCart, updateSavedCartTitle } from "./SaveCartPopUp.action";
import { hideClearAllCartModel, showClearAllCartModel } from "./ClearAllCartPopUp.action";

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = "CHECKOUT_SET_SELECTED_COMPANY_ADDRESS";
export const CHECKOUT_SET_CUSTOMER_INFO = "CHECKOUT_SET_CUSTOMER_INFO";
export const CHECKOUT_SET_PRIVATE_CUSTOMER = "CHECKOUT_SET_PRIVATE_CUSTOMER";
export const CHECKOUT_SET_SIGN_UP = "CHECKOUT_SET_SIGN_UP";
export const CHECKOUT_SET_DELIVERY = "CHECKOUT_SET_DELIVERY";
export const CHECKOUT_SET_COUNTRY = "CHECKOUT_SET_COUNTRY";
export const CHECKOUT_SET_PAYMENT = "CHECKOUT_SET_PAYMENT";
export const CHECKOUT_SET_CAMPAIGN_CODE = "CHECKOUT_SET_CAMPAIGN_CODE";
export const CHECKOUT_SET_ORDER_NOTE = "CHECKOUT_SET_ORDER_NOTE";
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = "CHECKOUT_ACCEPT_TERMS_OF_CONDITION";
export const CHECKOUT_SAVE_CART_ON_PURCHASE = "CHECKOUT_SAVE_CART_ON_PURCHASE";
export const CHECKOUT_SUBMIT = "CHECKOUT_SUBMIT";
export const CHECKOUT_SUBMIT_DONE = "CHECKOUT_SUBMIT_DONE";
export const CHECKOUT_SUBMIT_ERROR = "CHECKOUT_SUBMIT_ERROR";
export const CHECKOUT_SET_PAYMENT_WIDGET = "CHECKOUT_SET_PAYMENT_WIDGET";
export const CHECKOUT_SET_SELECTED_CERTIFICATE = "CHECKOUT_SET_SELECTED_CERTIFICATE";
export const CHECKOUT_SET_DELIVERYCONTACTPERSON = "CHECKOUT_SET_DELIVERYCONTACTPERSON";
export const CHECKOUT_SET_SELECTED_DELIVERYCONTACTPERSONPHONE = "CHECKOUT_SET_SELECTED_DELIVERYCONTACTPERSONPHONE";
export const CHECKOUT_SET_ORDERMARKING = "CHECKOUT_SET_ORDERMARKING";
export const CHECKOUT_SET_GENERALMARKING = "CHECKOUT_SET_GENERALMARKING";
export const CHECKOUT_SET_SELECTED_SALESREP = "CHECKOUT_SET_SELECTED_SALESREP";
export const CHECKOUT_SET_DOOPTIMIZATION = "CHECKOUT_SET_DOOPTIMIZATION";
export const SAVECART_MODAL_UPDATE = "SAVECART_MODAL_UPDATE";
export const CHECKOUT_SET_IS_VALID_FORM = "CHECKOUT_SET_IS_VALID_FORM";
export const CHECKOUT_SET_CHOICE_DELIVERY = "CHECKOUT_SET_CHOICE_DELIVERY";
export const CHECKOUT_SET_CHOICE_DELIVERY_DATE = "CHECKOUT_SET_CHOICE_DELIVERY_DATE";
export const CHECKOUT_SET_ORDER_HISTORY = "CHECKOUT_SET_ORDER_HISTORY";
export const UPDATE_ORDER_HISTORY_LOADING = "UPDATE_ORDER_HISTORY_LOADING";
export const CHECKOUT_SET_ORGANIZATION_USER = "CHECKOUT_SET_ORGANIZATION_USER";
export const UPDATE_ORGANIZATION_USER = "UPDATE_ORGANIZATION_USER";
export const CHECKOUT_SET_SHIPMENT_WIDGET= "CHECKOUT_SET_SHIPMENT_WIDGET"
export const CHECKOUT_SET_SHIPPING_OPTION= "CHECKOUT_SET_SHIPPING_OPTION"

export const setBusinessCustomer = (isBusinessCustomer) => ({
  type: CHECKOUT_SET_PRIVATE_CUSTOMER,
  payload: {
    isBusinessCustomer,
  },
});

export const setSignUp = (signUp) => ({
  type: CHECKOUT_SET_SIGN_UP,
  payload: {
    signUp,
  },
});

export const setAlternativeAddress = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: "alternativeAddress",
    data: {
      [propName]: value,
    },
  },
});

export const setCustomerDetails = (propName, value) => ({
  type: CHECKOUT_SET_CUSTOMER_INFO,
  payload: {
    key: "customerDetails",
    data: {
      [propName]: value,
    },
  },
});

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
  type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  payload: {
    selectedCompanyAddressId,
  },
});

export const setDelivery = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_DELIVERY,
    payload: {
      selectedDeliveryMethod: systemId,
    },
  });
  const { payload } = getState().checkout;
  return put("/api/checkout/setDeliveryProvider", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      if (result !== null && result.paymentWidget.displayDeliveryMethods) {
        dispatch(setPaymentWidget(result.paymentWidget));
      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setCountry = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_COUNTRY,
    payload: {
      selectedCountry: systemId,
    },
  });
  const { payload } = getState().checkout;
  return put("/api/checkout/setCountry", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(setPaymentWidget(result.paymentWidget));

      dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
          deliveryMethods: result.deliveryMethods,
          selectedDeliveryMethod: result.selectedDeliveryMethod,
        },
      });
      dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
          paymentMethods: result.paymentMethods,
          selectedPaymentMethod: result.selectedPaymentMethod,
        },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};
export const setAddress = (systemId) => (dispatch, getState) => {
  if (systemId) {
    dispatch({
      type: CHECKOUT_SET_COUNTRY,
      payload: {
        selectedCountry: systemId,
      },
    });
  }
  const { payload } = getState().checkout;
  return put("/api/checkout/setAddress", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(setPaymentWidget(result.paymentWidget));

      dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
          deliveryMethods: result.deliveryMethods,
          selectedDeliveryMethod: result.selectedDeliveryMethod,
        },
      });
      dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
          paymentMethods: result.paymentMethods,
          selectedPaymentMethod: result.selectedPaymentMethod,
        },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setDoOptimization = (value) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_DOOPTIMIZATION,
    payload: {
      doOptimization: value,
    },
  });
  const { payload } = getState().checkout;
  return put("/api/checkout/setDoOptimization", payload)
    .then((response) => response.json())
    // .then((result) => {
    //   dispatch(
    //     //loadCart()
    //   );

    // })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};


export const setPayment = (systemId) => (dispatch, getState) => {
  dispatch({
    type: CHECKOUT_SET_PAYMENT,
    payload: {
      selectedPaymentMethod: systemId,
    },
  });
  const { payload } = getState().checkout;
  return put("/api/checkout/setPaymentProvider", payload)
    .then((response) => response.json())
    .then((result) => {
      if (getState().cart.orderRows.length > 0) {
        dispatch(loadCart());
      }
      dispatch(setPaymentWidget(result.paymentWidget));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const reloadPayment = () => (dispatch, getState) => {
  const { paymentWidget, selectedPaymentMethod } = getState().checkout.payload;
  if (!paymentWidget) {
    return;
  }
  return dispatch(setPayment(selectedPaymentMethod));
};

export const reloadShipment = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/reloadShipmentWidget', payload)
        .then((response) => response.json())
        .then((result) => {
            if (result && result.shipmentWidget) {
                dispatch(setShipmentWidget(result.shipmentWidget));
            }
        })
        .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const setShippingOption = ({ shippingInfo, onSuccess, onError }) => (
    dispatch,
    getState
) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setShippingOption', {
        ...payload,
        shippingInfo,
    })
        .then((response) => response.json())
        .then((result) => {
            if (result?.paymentWidget) {
                dispatch(setPaymentWidget(result.paymentWidget));
            }
            dispatch(setSelectedShippingOption(shippingInfo));
            dispatch(loadCart());
            onSuccess && onSuccess();
        })
        .catch((ex) =>
            dispatch(
                catchError(ex, (error) => {
                    submitError(error);
                    onError && onError();
                })
            )
        );
};

const setSelectedShippingOption = (shippingInfo) => ({
    type: CHECKOUT_SET_SHIPPING_OPTION,
    payload: {
        shippingInfo,
    },
});

const setPaymentWidget = (paymentWidget) => ({
  type: CHECKOUT_SET_PAYMENT_WIDGET,
  payload: {
    paymentWidget,
  },
});

const setShipmentWidget = (shipmentWidget) => ({
    type: CHECKOUT_SET_SHIPMENT_WIDGET,
    payload: {
        shipmentWidget,
    },
});

export const setOrderNote = (orderNote) => ({
  type: CHECKOUT_SET_ORDER_NOTE,
  payload: {
    orderNote,
  },
});

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
  type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  payload: {
    acceptTermsOfCondition,
  },
});

export const saveCartOnPurchase = (saveCartOnPurchase) => ({
  type: CHECKOUT_SAVE_CART_ON_PURCHASE,
  payload: {
    saveCartOnPurchase,
  },
});

export const setCampaignCode = (campaignCode) => ({
  type: CHECKOUT_SET_CAMPAIGN_CODE,
  payload: {
    campaignCode,
  },
});

export const submitCampaignCode = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  return put("/api/checkout/setCampaignCode", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(setPaymentWidget(result.paymentWidget));
      // reset error of campaign code
      dispatch(
        submitError({
          modelState: {
            campaignCode: [],
          },
        })
      );
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => submitError(error)));
      // restore the initial cart
      dispatch(loadCart());
    });
};

export const submitSaveCart = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  return put("/api/checkout/saveCart", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(hideSaveCartModel());
      dispatch(showModal(result.message, result.btntext));
      // // reset error
      dispatch(
        submitError({
          modelState: {
            saveCart: [],
          },
        })
      );
    })
    .catch((ex) => {
      dispatch(catchError(ex, (error) => submitError(error)));
    })
    .finally(() => {
      dispatch(submitDone(null));
    });
};

export const submit = () => (dispatch, getState) => {
  const { payload } = getState().checkout;
  const { cart } = getState();
  return _submit("/api/checkout", payload, cart, dispatch);
};

export const verify = (url, orderId, payload) => (dispatch, getState) => {
  const model = getState().checkout.payload;
  model.orderId = orderId;
  model.payload = payload;
  return _submit(url, model, dispatch);
};

const _submit = (url, model, cartDetails, dispatch) => {
  return post(url, model)
    .then((response) => response.json())
    .then((result) => {
      window.sessionStorage.setItem('cartdetails', JSON.stringify(cartDetails))
      dispatch(submitDone(result));
    })
    .catch((ex) => {
      if (ex.response) {
        ex.response.json().then((error) => {
          dispatch(submitError(error));
          dispatch(submitDone(null));
          // reload the cart, it might be changed after validation
          dispatch(loadCart());
        });
      } else {
        dispatch(submitError(ex));
      }
    });
};

export const submitRequest = () => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    isSubmitting: true,
    errors: [],
  },
});

export const submitDone = (result) => ({
  type: CHECKOUT_SUBMIT,
  payload: {
    result,
    isSubmitting: false,
  },
});

export const submitError = (error) => ({
  type: CHECKOUT_SUBMIT_ERROR,
  payload: {
    error,
  },
});
export const setSelectedCertificateId = (value) => ({
  type: CHECKOUT_SET_SELECTED_CERTIFICATE,
  payload: {
    selectedCertificateId: value,
  },
});
export const setSelectedSalesRepId = (value) => ({
  type: CHECKOUT_SET_SELECTED_SALESREP,
  payload: {
    selectedSalesRepId: value,
  },
});
export const setDeliveryContactPerson = (value) => ({
  type: CHECKOUT_SET_DELIVERYCONTACTPERSON,
  payload: {
    deliveryContactPersonName: value,
  },
});
export const setDeliveryContactPersonPhoneNumber = (value) => ({
  type: CHECKOUT_SET_SELECTED_DELIVERYCONTACTPERSONPHONE,
  payload: {
    deliveryContactPersonPhoneNumber: value,
  },
});
export const setOrderMarking = (value) => ({
  type: CHECKOUT_SET_ORDERMARKING,
  payload: {
    orderMarking: value,
  },
});
export const setGeneralMarking = (value) => ({
  type: CHECKOUT_SET_GENERALMARKING,
  payload: {
    generalNote: value,
  },
});

export const updatepreferredDeliveryDate = (value) => (dispatch, getState) => {

  const { payload } = getState().checkout;
  payload.preferredDeliveryDate = value.preferredDeliveryDate;
  return put("/api/checkout/setPreferedDeliveryDate", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(setPaymentWidget(result.paymentWidget));
      dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
          deliveryMethods: result.deliveryMethods,
          selectedDeliveryMethod: result.selectedDeliveryMethod,
        },
      });
      dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
          paymentMethods: result.paymentMethods,
          selectedPaymentMethod: result.selectedPaymentMethod,
        },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};
export const updateCoFreight = (value) => (dispatch, getState) => {
  const { payload } = getState().checkout;
  payload.oneDelivery = value.preferedcofreight;
  return put("/api/checkout/setCoFreight", payload)
    .then((response) => response.json())
    .then((result) => {
      dispatch(loadCart());
      dispatch(setPaymentWidget(result.paymentWidget));
      dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
          deliveryMethods: result.deliveryMethods,
          selectedDeliveryMethod: result.selectedDeliveryMethod,
        },
      });
      dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
          paymentMethods: result.paymentMethods,
          selectedPaymentMethod: result.selectedPaymentMethod,
        },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => submitError(error))));
};

export const clearAllCart = () => (dispatch) => {
  return get('/api/cart/clearallcart')
    .then(response => response.json())
    .then((result) => {
      dispatch(hideClearAllCartModel())
    })
    .then(cart => dispatch({
      type: CART_RECEIVE,
      payload: cart,
    }))
    .catch(ex => dispatch(catchError(ex, (error) => submitError(error))));
}

export const setOrderHistory = () => (dispatch) => {
  dispatch(updateOrderHistoryLoading(true));
  return get('/api/checkout/orderHistory')
    .then(response => response.json())
    .then((result) => {
      dispatch(receiveOrderHistory(result))
      dispatch(updateOrderHistoryLoading(false));
    })
    .catch(ex => dispatch(catchError(ex, (error) => {
      submitError(error)
      dispatch(updateOrderHistoryLoading(false));
    })));
}

export const setOrganizationUser = () => (dispatch) => {
  return get('/api/checkout/organizationUser')
    .then(response => response.json())
    .then((result) => {
      dispatch(receiveOrganizationUser(result))
    })
    .catch(ex => dispatch(catchError(ex, (error) => {
      submitError(error)
    })));
}

export const receiveOrderHistory = (orderHistory) => ({
  type: CHECKOUT_SET_ORDER_HISTORY,
  payload: orderHistory,
});

export const updateOrderHistoryLoading = (status) => ({
  type: UPDATE_ORDER_HISTORY_LOADING,
  payload: status,
});

export const openSaveCartModel = () => (dispatch) => {
  dispatch(showSaveCartModel());
}

export const updateSaveCartValue = (value) => (dispatch) => {
  dispatch(updateSavedCartTitle(value));
}

export const openClearAllCartModel = () => (dispatch) => {
  dispatch(showClearAllCartModel());
}
export const setIsValidForm = (isValidForm) => ({
  type: CHECKOUT_SET_IS_VALID_FORM,
  payload: {
    isValidForm,
  },
});

export const setChoiceOfDelivery = (isChoiceDelivery) =>
({
  type: CHECKOUT_SET_CHOICE_DELIVERY,
  payload: {
    isChoiceDelivery,
  },
});

export const setChoiceOfDeliveryDate = (date, orderId) =>
({
  type: CHECKOUT_SET_CHOICE_DELIVERY_DATE,
  payload: {
    choiceDeliveryDate: date,
    choiceDeliveryDateOrderId: orderId,
  },
});

export const receiveOrganizationUser = (data) => ({
  type: CHECKOUT_SET_ORGANIZATION_USER,
  payload: data,
});

export const setSelectedOrganizationUser = (userId) => ({
  type: UPDATE_ORGANIZATION_USER,
  payload: userId,
});